import { Helmet } from "react-helmet";

export default function StructuredDataSeoConfig() {
  const isProd = import.meta.env.VITE_PROD === "true";

  return isProd ? (
    // Structured Data: Organization + WebSite + SoftwareApplication
    <Helmet>
      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Darvin",
            "url": "https://darvin.dev/",
            "logo": "https://darvin.dev/assets/logo.svg",
            "sameAs": [
            "https://www.linkedin.com/company/darvindotdev",
            "https://twitter.com/DarvinDev"
            ],
            "description": "Turn plain language into native Flutter Mobile Apps — no code needed."
        }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "WebSite",
            "url": "https://darvin.dev/",
            "name": "Darvin",
            "publisher": {
            "@type": "Organization",
            "name": "Darvin"
            }
        }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Darvin AI",
            "applicationCategory": "DeveloperApplication",
            "operatingSystem": "Android, iOS",
            "description": "Generate production-ready Flutter Mobile Apps from plain language — no code required."
        }`}
      </script>
    </Helmet>
  ) : null;
}
